import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTrending3"><Path d="M15.75 6.75H21.25V12.25M20.7361 7.275L15.0007 13.0022C13.8955 14.1058 12.1051 14.1051 11.0007 13.0007C9.89575 11.8958 8.10425 11.8958 6.99928 13.0007L2.75 17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTrending3;
